import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './adhoc-backup.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'adhoc-backup',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./adhoc-backup.scss')],
  template: require('./adhoc-backup.html')
})

export class AdhocBackup {
  @Input('isVisible') isVisible: boolean;
  @Input('selectedEntity') selectedEntity;
  @Output('onRequestStatusChange') emitter = new EventEmitter();

  private subscribeHandler;
  private active: boolean = true;
  private retentionPeriod;

  private isRequestPending: boolean = false;

  private emitData = {
    'status': '',
  };

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit(f: NgForm) {
    if( f.valid ) {
      this.isRequestPending = true;
      this.emitData.status = 'pending';
      this.emitter.emit(this.emitData);
      this.runAdhocBackup(f.value);
    }
  }

  onCancelButtonClicked() {
    this.emitter.emit();
  }

  ngOnChanges(changes) {
    if ( changes.isVisible && changes.isVisible.currentValue ) {
      this.reset();
    }
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  runAdhocBackup(formValue) {
    if(formValue && formValue.retention && this.selectedEntity && this.selectedEntity.entity_id !== '' &&
       this.selectedEntity.vcenter_instanceId !== '') {
         let retentionObj = {'retention': {'days': formValue.retention }};
          this.subscribeHandler = this.service.runAdhocBackup(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId, retentionObj)
            .subscribe(
              res => {
                this.handleSuccess();
              },
              error => this.handleError(error),
              () => {}
            );
    }
    else{
    }
  }

  handleSuccess() {
    this.isRequestPending = false;
    this.emitData.status = 'success';
    this.emitter.emit(this.emitData);
  }

  handleError(error) {
    this.isRequestPending = false;
    this.emitData.status = 'error';
    this.emitter.emit(this.emitData);
  }

  reset() {
    this.active = false;
    setTimeout(() => this.active = true, 0);
    this.retentionPeriod = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/adhoc-backup/adhoc-backup.component.ts